export enum DARWIN_EXPERIMENT_NAMES {
  WEB_OFFERS_LOGIN_TEST = 'web_offers_login_test_2024',
}
